/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    disconnect: {
        from: "IndmerXR",
        success: "Vous avez été déconnecté de"
    },
    redirect: {
        label: "Vous allez être redirigé vers votre",
        linkName: "portail de connexion"
    }
};